import {post} from '../request';

/**
 * 用户管理
 */
/**
 * 列表
 * @param data
 * @returns {*}
 */
export function userIndex(data) {
    return post("admin/user/index", data)
}

/**
 * 黑名单
 * @param data
 * @returns {*}
 */
export function lockUser(data) {
    return post("admin/user/is_lock", data)
}

/**
 * 享有免费次数
 * @param data
 * @returns {*}
 */
export function freeUser(data) {
    return post("admin/user/is_free", data)
}

/**
 * 充值余额
 * @param data
 * @returns {*}
 */
export function setpay(data) {
    return post("admin/user/pay", data)
}